import { areLocationScopesEqual, formatLocationScopeLabel } from './locationScopes';

export function getUserLocationStatusDisplay(locations, statuses, { loading = false, error = '' } = {}) {
  if (loading) return { label: 'Consultando…', dateLabel: '', tooltip: 'Consultando el estado de las sedes.', color: 'default' };
  if (error) return { label: 'No disponible', dateLabel: '', tooltip: error, color: 'default' };
  if (!locations.length) return { label: 'Sin sede', dateLabel: '', tooltip: 'Este usuario no tiene una sede asignada.', color: 'default' };

  const entries = locations.map((location) => ({
    location,
    status: statuses.find((entry) => areLocationScopesEqual(entry.locationScope, location)),
  }));
  const confirmedCount = entries.filter((entry) => entry.status?.status === 'up_to_date').length;
  const label = confirmedCount === entries.length ? 'Todo está al día' : 'Requiere revisión';
  const tooltip = entries.map(({ location, status }) => {
    const currentLabel = status?.status === 'up_to_date' ? 'Todo está al día' : 'Requiere revisión';
    return [
      formatLocationScopeLabel(location), currentLabel,
      status?.updatedAtLabel ? `Última actualización: ${status.updatedAtLabel}` : '',
      status?.updatedByName || status?.updatedByEmail
        ? `Actualizado por: ${[status.updatedByName, status.updatedByEmail].filter(Boolean).join(' · ')}` : '',
      status?.confirmedAtLabel ? `Última confirmación: ${status.confirmedAtLabel}` : '',
      status?.confirmedByName || status?.confirmedByEmail
        ? `Por: ${[status.confirmedByName, status.confirmedByEmail].filter(Boolean).join(' · ')}` : '',
      Number(status?.pendingRequestsCount) > 0 ? `${status.pendingRequestsCount} solicitud(es) pendiente(s)` : '',
    ].filter(Boolean).join('\n');
  }).join('\n\n');
  const dates = [...new Set(entries.map((entry) => entry.status?.updatedAtLabel || entry.status?.confirmedAtLabel).filter(Boolean))];
  return {
    label,
    dateLabel: dates.map((date) => date.replace(/\(hora de Nueva York,\s*(GMT[+-]\d{2}:\d{2})\)/g, '($1)')).join(' · '),
    tooltip,
    color: confirmedCount === entries.length ? 'success' : 'warning',
  };
}
